import defaultState from "./state";

const mantenedoresReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "SET_DATA_LISTAS": {
      return { ...state, ...action.mantenedores };
    }
    case "SET_DO_UPDATE": {
      return Object.assign({}, state, {
        doUpdate: action.doUpdate,

      });
    }
    case "SET_ROLES_LIST": {
      return Object.assign({}, state, {
        roles: action.roles,

      });
    }
    case "SET_PERFILES_LIST": {
      return Object.assign({}, state, {
        perfiles: action.perfiles,

      });
    }
    case "SET_EMPRESAS_LIST": {
      return Object.assign({}, state, {
        empresas: action.empresas
      })
    }
    case "LOADING_MANTENEDORES": {
      return Object.assign({}, state, {
        isLoading: action.isLoading,
      });
    }
    case "LOADING_ROLES": {
      return Object.assign({}, state, {
        isLoadingRoles: action.isLoadingRoles,
      });
    }
    case "SET_ROL_FUNCIONALITIES": {
      return Object.assign({}, state, {
        selectedFuncionalities: action.func,
      });
    }
    case "SET_EVENT_DATA_ROL": {
      return Object.assign({}, state, {
        eventDataRol: action.eventDataRol,
      });
    }
    default:
      return state;
  }
};
export default mantenedoresReducer;
